import base from "./tenants/base.config";
import coco from "./tenants/coco.config";
import dgeErp from "./tenants/dge-erp.config";
import { deepMerge } from "./tenants/deepMerge";
import { TENANT_IDS } from "./tenants/tenantIds";

const REGISTRY = {
    [TENANT_IDS.DGE_ERP]: dgeErp,
    [TENANT_IDS.COCO]: coco,
    [TENANT_IDS.TEST_CERP]: coco, 
};

//====================================== BASE ID ========================================//

// export const tenantId = "TEST_CERP";
//export const tenantId = "DGES_ERP";
export const tenantId = "COCO_ERP";


function resolveTenant() {

    const override = REGISTRY[tenantId];

    if (!override) {
        throw new Error(
            `[tenant config] Unknown REACT_APP_TENANT_ID: ${tenantId}. ` +
            `No config exists for this ID.`
        );
    }

    return deepMerge(base, override);
}

const tenant = resolveTenant();

export default tenant;
export { TENANT_IDS };
